import BaseEchart from './base-echart.vue'
export default BaseEchart